module.exports = __webpack_public_path__ + "static/media/018.33a0e0d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/018.jpg
// module id = 491
// module chunks = 0